<template>
  <v-card v-if='$vuetify.breakpoint.mdAndUp' tile flat :loading='loading' :loader-height='6'>
    <div :class='backgroundClass'>
      <v-container :class="fullWidth ? 'wide-container' : ''">
        <v-row no-gutters align='center'>
          <v-col>
            <span :class='titleClass'>
              {{ title }}
            </span>
            <br v-if="$vuetify.breakpoint.smAndDown">
            <span :class='subtitleClass'>{{ subtitle }}</span>
          </v-col>
          <v-col class='text-right' align-self='start' cols='auto'>
            <slot name='rightSide'></slot>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
    </div>
  </v-card>
</template>

<script>

export default {
  name: 'section-title',
  props: {
    title: {
      required: true
    },
    subtitle: {
      required: false,
      default: ''
    },
    fullWidth: {
      required: false,
      type: Boolean,
      default: false
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    
  }),
  computed: {
    backgroundClass() {
      return this.$vuetify.breakpoint.smAndDown ? '' : 'mt-5'
    },
    titleClass () {
      if (this.$vuetify.breakpoint.xs) {
        return 'display-1 primary--text text-uppercase font-weight-light'
      }
      return 'display-2 primary--text text-uppercase font-weight-light'
    },
    subtitleClass () {
      if (this.$vuetify.breakpoint.xs) {
        return 'headline grey--text text-uppercase font-weight-light'
      }
      return 'display-1 grey--text text-uppercase font-weight-light'
    }
  }
}
</script>

<style scoped>
.wide-container {
  max-width: 1680px !important;
  margin-left: 0px !important;
  padding-left: 16px !important;
}
</style>